/** Generated by scripts/generate-build-version.mjs — do not edit manually. */
export const BUILD_VERSION = "07dac34-11067";
